/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OIDCTokensInfo } from './OIDCTokensInfo';
import {
    OIDCTokensInfoFromJSON,
    OIDCTokensInfoFromJSONTyped,
    OIDCTokensInfoToJSON,
} from './OIDCTokensInfo';

/**
 * 
 * @export
 * @interface TokenContainerAllOf
 */
export interface TokenContainerAllOf {
    /**
     * 
     * @type {string}
     * @memberof TokenContainerAllOf
     */
    user_token: string;
    /**
     * 
     * @type {Array<OIDCTokensInfo>}
     * @memberof TokenContainerAllOf
     */
    oidc_tokens?: Array<OIDCTokensInfo>;
}

/**
 * Check if a given object implements the TokenContainerAllOf interface.
 */
export function instanceOfTokenContainerAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_token" in value;

    return isInstance;
}

export function TokenContainerAllOfFromJSON(json: any): TokenContainerAllOf {
    return TokenContainerAllOfFromJSONTyped(json, false);
}

export function TokenContainerAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenContainerAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_token': json['user_token'],
        'oidc_tokens': !exists(json, 'oidc_tokens') ? undefined : ((json['oidc_tokens'] as Array<any>).map(OIDCTokensInfoFromJSON)),
    };
}

export function TokenContainerAllOfToJSON(value?: TokenContainerAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_token': value.user_token,
        'oidc_tokens': value.oidc_tokens === undefined ? undefined : ((value.oidc_tokens as Array<any>).map(OIDCTokensInfoToJSON)),
    };
}

